/**
 * @generated SignedSource<<59dc46ea0e237b319fb376ace3966dea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GenerateTicketReplyDraftInput = {
  ticketId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type generateTicketReplyDraftMutation$variables = {
  input: GenerateTicketReplyDraftInput;
};
export type generateTicketReplyDraftMutation$data = {
  readonly generateTicketReplyDraft: {
    readonly clientMutationId: string | null;
    readonly draftText: string;
    readonly modelVersion: string | null;
  } | null;
};
export type generateTicketReplyDraftMutation = {
  variables: generateTicketReplyDraftMutation$variables;
  response: generateTicketReplyDraftMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateTicketReplyDraftPayload",
    "kind": "LinkedField",
    "name": "generateTicketReplyDraft",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modelVersion",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "generateTicketReplyDraftMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "generateTicketReplyDraftMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d384df33bda7cd825092f18e79785268",
    "id": null,
    "metadata": {},
    "name": "generateTicketReplyDraftMutation",
    "operationKind": "mutation",
    "text": "mutation generateTicketReplyDraftMutation(\n  $input: GenerateTicketReplyDraftInput!\n) {\n  generateTicketReplyDraft(input: $input) {\n    clientMutationId\n    draftText\n    modelVersion\n  }\n}\n"
  }
};
})();

(node as any).hash = "604cd606ede92b09612a55d52e3f687f";

export default node;
